export interface IVerticalMenuItem {
	id: string;
	text?: string;
	title?: string;
	iconClass?: string;
	children?: IVerticalMenuItem[];
	placement?: string;
}

export const VERTICAL_MENU_SEPARATOR_ITEM: IVerticalMenuItem = {
	id: 'SEPARATOR',
	//text: '--------------------------------',
};